import type { PersonStub, Name, Contacts, Address } from '../'

// TODO: Deprecate -- use zPerson instead
export const createPerson = <Person>(
  stub: PersonStub = { name: {}, contacts: {}, address: {} },
) => {
  /** Scaffolds a person object. Accepts optional partial data and fleshes it out */
  return {
    name: createName(stub?.name),
    contacts: createContacts(stub?.contacts),
    ssn: stub?.ssn || '',
    birthDate: stub?.birthDate || '',
    partId: '',
    hashId: '',
    address: createAddress(stub?.address),
    useLookup: false,
  }
}

export const createName = (stub: Partial<Name> = {}): Name => {
  /** Scaffolds a name object. Accepts optional partial data and fleshes it out */
  return {
    first: stub.first || '',
    last: stub.last || '',
  }
}

export const createContacts = (stub: Partial<Contacts> = {}): Contacts => {
  /** Scaffolds a contacts object. Accepts optional partial data and fleshes it out */
  return {
    mobile: stub.mobile || '',
    email: stub.email || '',
    landline: stub.landline || '',
  }
}

export const createAddress = (stub: Partial<Address>): Address => {
  /** Scaffolds an address object. Accepts optional partial data and fleshes it out */
  return {
    co: stub.co || '',
    street: stub.street || '',
    postcode: stub.postcode || '',
    city: stub.city || '',
    countryCode: stub.countryCode || 'NONE',
  }
}
